/* eslint-disable init-declarations, react/jsx-no-bind */

import Modal from "react-bootstrap-modal";
import PropTypes from "prop-types";
import React from "react";
import {connect} from "react-redux";

class PostPurchaseModal extends React.Component {

  static propTypes = {
    "postPurchaseModal": PropTypes.oneOfType(
      [
        PropTypes.bool,
        PropTypes.object
      ]
    ).isRequired
  };

  static defaultProps = {"postPurchaseModal": false}

  state = {"show": true}

  handleHideModal = () => {
    this.setState({"show": false});
  }

  render () {
    const {postPurchaseModal} = this.props;
    const {show} = this.state;
    return (
      postPurchaseModal &&
        <Modal
          className="post-purchase-modal"
          onHide={this.handleHideModal}
          show={show}
        >
          <Modal.Body>
            <a href={postPurchaseModal.link_url}>
              <img src={postPurchaseModal.image_url} />
            </a>
          </Modal.Body>
        </Modal>
    );
  }
}

const mapStateToProps = state => ({"postPurchaseModal": state.postPurchaseModal});

export default connect(mapStateToProps)(PostPurchaseModal);
